import type { SessionService } from '@efdigital/ll-addon-auth';
import type { Answer, Quiz } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { asAsyncBelongsTo } from '@efdigital/ll-admin-v2/data/async-setter.ts';
import { findQuizWithContent } from '@efdigital/ll-admin-v2/data/builders/quiz/pages.ts';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';
import { Type } from '@warp-drive/core/types/symbols';

import type { ProgramsProgramCohortModel } from '../../cohort.ts';

export type ParamsCertificateId = {
  quiz_id: string;
};

export type ProgramsProgramCohortContentCertificateModel =
  ProgramsProgramCohortModel &
    ParamsCertificateId & {
      quiz: Quiz;
      answers: Answer;
    };

export default class ProgramsProgramCohortContentCertificateRoute extends Route<ProgramsProgramCohortContentCertificateModel> {
  @service declare store: Store;
  @service declare session: SessionService;
  async model(params: ParamsCertificateId) {
    const quiz = (await this.store.request(findQuizWithContent(params.quiz_id)))
      .content.data;
    const answers = this.store.createRecord<Answer>(DataTypeQuiz.Answer, {
      quiz: asAsyncBelongsTo(quiz),
      modified: new Date().toISOString(),
      user: await this.session
        .getCurrent()
        .then((session) => session.userId ?? ''),
      values: (quiz.questions || []).map((question) => ({
        [Type]: DataTypeQuiz.AnswerValue,
        qid: question.qid,
        value: null,
      })),
      mark: {
        [Type]: DataTypeQuiz.QuizMark,
        score: 0,
        scores: [],
        marks: [],
        totals: [],
        validation: [],
      },
      draft: false,
      consent: false,
      selections: [],
      xXapiContext: [],
    });

    return {
      ...(this.modelFor(
        'programs.program.cohort.content'
      ) as ProgramsProgramCohortModel),
      ...params,
      quiz,
      answers,
    };
  }
}
